export default {
	type: 'object',
	properties: {
		userId: { type: 'string' },
		campaignId: { type: 'string' },
		totalCreatorPoints: { type: 'number' },
	},
	required: ['userId', 'campaignId', 'totalCreatorPoints'],
	additionalProperties: false,
}
